import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { handleFilter } from '../../store/actions';

import LocationOneHeader from './LocationOneHeader';

export const mapStateToProps = ({ viewer, router }) => {
  return {
    showSearch: viewer.showSearchAndAppliedFilters,
    searchType: router.location.pathname.split('/')[1] === 'sites' ? 'sites' : 'buildings',
  };
};

export const mapDispatchToProps = dispatch => ({
  handleSearchClick: name => dispatch(handleFilter('', name)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationOneHeader));



// WEBPACK FOOTER //
// ./src/components/LocationOneHeader/LOHeaderWrapper.js